/* Utils */
import { useState } from 'react';

/* Store */
import useModalsStore from 'Stores/Modals';
import useOrdersStore from 'Stores/Orders';

/* Components */
import Modal from 'Components/Modal';
import FormInput from 'Components/FormInput';

/* Styles */
import './style.scss';

const ShowFurniture = (props) => {
	const hideModal = useModalsStore(state => state.hideModal);
	const sentOrder = useOrdersStore(state => state.sentOrder);
	const updateStatus = useOrdersStore(state => state.updateStatus);
	const sendingOrder = useOrdersStore(state => state.sendingOrder);
	const { params: { order } } = props;

	const [form, setForm] = useState({
		carrierName: 'La Poste',
		trackingNumber: '',
		trackingUrl: 'https://www.laposte.fr/outils/suivre-vos-envois?code='
	});
	const [errors, setErrors] = useState({});

	const validateForm = () => {
		const newErrors = {};

		if (!form.carrierName) {
			newErrors.carrierName = { message: 'Remplir le champs' };
		}

		if (!form.trackingNumber) {
			newErrors.trackingNumber = { message: 'Remplir le champs' };
		}

		return newErrors;
	};

	const handleSubmit = async () => {
		const hasErrors = validateForm();
		setErrors(hasErrors);

		if (Object.keys(hasErrors).length > 0) {
			return;
		}

		const params = {
			orderid: order.id,
			...form
		};
		const isSuccess = await sentOrder(order, params);

		if (isSuccess) {
			hideModal();
			const trackings = [{
				carrierName: form.carrierName,
				trackingNumber: form.trackingNumber,
				trackingUrl: `https://www.laposte.fr/outils/suivre-vos-envois?code=${form.trackingNumber}`
			}];
			await updateStatus(order, 'sent', trackings);
		}
	};

	const navigation = { icon: 'utilitary_close', action: () => hideModal() };
	const button = { label: sendingOrder ? null : 'Envoyer', action: () => handleSubmit(), isLoading: sendingOrder };
	return (
		<Modal title={`Envoyer la commande #000${order.order_number}`} navigation={navigation} button={button}>
			<div className="sent-modal wrapper">
				<div className="sent-modal-content">
					<p className="title">Remplir les informations de suivi</p>
					<div className="inputs">
						<FormInput
							name="carrierName"
							label="Nom du transporteur"
							placeholder="Ex: La Poste"
							value={form.carrierName}
							setValue={(value) => setForm({ ...form, carrierName: value })}
							errors={errors}
						/>

						<FormInput
							name="trackingNumber"
							label="Numéro de suivi"
							placeholder="Ex: 1L02425331547"
							value={form.trackingNumber}
							setValue={(value) => setForm({ ...form, trackingNumber: value })}
							errors={errors}
						/>
					</div>
				</div>
			</div>
		</Modal>
	);
};

ShowFurniture.propTypes = {
	params: PropTypes.shape({
		order: PropTypes.object.isRequired
	}).isRequired
};

export default ShowFurniture;
